import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { InputAdornment } from '@mui/material'
import React from 'react'

type MyInputProps = TextFieldProps & {
  max?: number
  type?: string
  maxLength?: number
  endAdornment?: React.ReactNode
}

const StyledTextField = styled(TextField)({
  // Add your styles here
})

const SizeTextFieldInput = (props: MyInputProps) => {
  const { max, maxLength, endAdornment, ...rest } = props

  return (
    <StyledTextField
      {...rest}
      inputProps={{ max, maxLength }}
      InputProps={{
        endAdornment: endAdornment ? (
          <InputAdornment position="end" sx={{ marginRight: '-8px' }}>
            {endAdornment}
          </InputAdornment>
        ) : undefined
      }}
      style={{ fontSize: '14px' }}
      type={props.type ?? 'number'}
    />
  )
}

export default SizeTextFieldInput
